import EventEmitter from 'events';

export const eventEmitter = new EventEmitter();
export const DISCONNECTED_EVENT_NAME = 'disconnected';
